import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HostService } from '../host/host.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Injectable()
export class PdvService {
  pdvs: any[] = [];
  db: any;
  host: string;
  subscriptions: Subscription[] = [];
  idPdv = 'aFNBMEMwdjd2MHVXbnRlb01UemhmZz09';
  // idPdv = 'S0Y5VjNKY1dud1VJVFdzTWR4ZDdvZz09';
  // idGoogle = '189328687894-llifpo517nfe428at8urisr9sljk3aoq.apps.googleusercontent.com';
  // idFacebook = "4843700819038035";
  ///for onesignal

  // sender_id = '456611656149';
  // oneSignalAppId = '8ab629ac-857e-4120-853f-beda826737d1';
  public pdv: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public orderTypes: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public orderTypesAvailability: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public nbrOffersAuthorizedSite: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  constructor(
    private http: HttpClient,
    private hostService: HostService
  ) {
    this.host = this.hostService.host;
  }

  getTimes(orderType) {
    return new Promise((resolve, reject) => {
      let sub1 = this.orderTypes.subscribe((orderTypes) => {
        if (orderTypes.length > 0) {
          let index = orderTypes.findIndex(o => o.id === orderType);
          if (index > -1) {
            let avail = orderTypes[index];
            let dateDb = (avail.middayStartSite) ? this.getDate(avail.middayStartSite) : null;
            let dateFin = (avail.middayEndSite) ? this.getDate(avail.middayEndSite) : null;
            let dateDb2 = (avail.eveningStartSite) ? this.getDate(avail.eveningStartSite) : null;
            let dateFin2 = (avail.eveningEndSite) ? this.getDate(avail.eveningEndSite) : null;
            let times = [];
            if (dateDb && dateFin) {
              times = times.concat(this.getTimesArray(dateDb, dateFin, avail.minDelay));
            }
            if (dateDb2 && dateFin2) {
              times = times.concat(this.getTimesArray(dateDb2, dateFin2, avail.minDelay));
            }
            resolve(times);
          } else {
            resolve([]);
          }
        } else {
          resolve([]);
        }
      })
      this.subscriptions.push(sub1);
    })
  }

  getDate(fullDate) {
    let now = new Date();
    let arr = fullDate.split(/[- : T]/);
    let date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), arr[3], arr[4], 0);
    return date;
  }

  getTimesArray(dateDb, dateFin, maxDelay) {
    let now = new Date();
    let date = new Date();
    if (dateDb > dateFin) {
      date.setDate(date.getDate() + 1);
      dateFin.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    }
    let dateMin = (dateDb > now) ? new Date(dateDb.getTime() + maxDelay * 60000) : new Date(now.getTime() + maxDelay * 60000);
    let dateMax = new Date(dateFin.getTime());
    dateMin.setSeconds(0, 0);
    dateMax.setSeconds(0, 0);
    let i = dateMin;
    let times = [];
    while (i < dateMax) {
      times.push(i);
      i = new Date(i.getTime() + 300000);
    }
    return times;
  }

  getModesByPdv() {
    return this.http.get(this.host + 'ordertypes');
  }
  getPdv() {
    return this.http.get(this.host + 'pdv');
  }
  getPdvInfo() {
    return this.http.get(this.hostService.host + 'pdv/miniInfo');
  }
  checkAuthorizedCity(postalCode) {
    return this.http.post(this.host + 'authorizedCity', { postalCode: postalCode })
  }
  getAuthorizedCities() {
    return this.http.get(this.host + 'authorizedCities')
  }
  getPaymentModes() {
    return this.http.get(this.host + 'paymentmodes');
  }
  getPaymentMode(orderType) {
    return this.http.get(this.host + 'paymentmodes/ordertype/'+orderType);
  }
  getCompositionsOfCarte() {
    return this.http.get(this.hostService.host + 'ingredients/compositions');
  }
  getPdvAvailability() {
    return this.http.get(this.host + 'pdv/availability');
  }
  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
}



// WEBPACK FOOTER //
// ./src/providers/pdv/pdv.service.ts